/**
 * 是否是参数类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */
import isType from './is-type';

var isError = function (value) {
  return isType(value, 'Error');
};

export default isError;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/is-error.js
// module id = 84
// module chunks = 0